import { APP_PERMISSIONS } from '@exam-center/permission';
import { useHasPermission } from '@shared/permissions';

import { AdminExamCenterDetailsFormLogic } from '../admin-exam-center-details-form-logic';
import { AdminExamCenterReadonlyDetails } from '../admin-exam-center-readonly-details';

export default function ExamCenterDetails() {
  const hasUpdateExamCenterDetailsPermission = useHasPermission(
    APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.EXAM_CENTER.UPDATE,
  );

  if (hasUpdateExamCenterDetailsPermission) {
    return <AdminExamCenterDetailsFormLogic />;
  }

  return <AdminExamCenterReadonlyDetails />;
}
